import { useAuthStore } from '@/stores/authStore';
import { canAccess } from '@/utils/permissions';
import type { Role } from '@/types';

export function useRBAC() {
  const user = useAuthStore(s => s.user);
  const role = user?.role as Role | undefined;

  return {
    role,
    user,
    can: (section: string) => (role ? canAccess(role, section) : false),
    isRole: (...roles: Role[]) => (role ? roles.includes(role) : false),
    isSuperAdmin: role === 'super_admin',
    isManager: role === 'super_admin' || role === 'category_manager' || role === 'team_lead',
    isSales: role === 'sales_executive',
    isClinical: role === 'doctor' || role === 'hospital',
  };
}
